export default [
  {
    url: '/',
    title: 'Vape Pen & E-Cigarette Online Shop 🛒 | Welcome to Vuse',
    description:
      'Shop for our exclusive ecigarettes, liquids and accessories directly online. Get up to 30% off pods and free shipping with our Vuse subscription plan. Previously govype.ca'
  },
  {
    url: '/benefits/',
    title: 'Why Order your Vape Online 💳? | Vuse',
    description:
      'Did you know that shopping online gives you access to many benefits such as promotions and a rewards program? Discover all the perks here! Previously govype.ca'
  },
  {
    url: '/buy-online/engravable/',
    title: 'Engravable ePod - Shop our Vape Online | By Vuse',
    description:
      'Customize your electronic cigarette according to your taste with the engravable ePod. The ultimate experience with a tailored ePod. Shop on our online store! Previously govype.ca'
  },
  {
    url: '/buy-online/epen-3/',
    title: 'ePen ➡️ Shop our Vape Pen Online | By Vuse',
    description:
      'With its new technology, ePen 3 offers you a rich and outstanding vaping experience. Discover our exclusive designs on our online shop. Previously govype.ca'
  },
  {
    url: '/buy-online/epod-devices/',
    title: 'ePod Devices ➡️ Shop our E-Cigarette Online | By Vuse',
    description:
      'For a compact and stylish vape, ePod is an electronic cigarette that offers a wide choice of flavours and is available in many colours! Find more online! Previously govype.ca'
  },
  {
    url: '/buy-online/epod/',
    title: 'ePod Solo Device ➡️ Shop our E-Cigarette Online | By Vuse',
    description:
      'ePod is a sleek and elegant electronic smoke that features a wide range of flavours and is offered in a wide variety of colours! Check it out now! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epen-3-cartridges/',
    title: 'ePen Pods ➡️ Order Vape Liquid Online | By Vuse',
    description:
      'Order from a large variety of flavours, all exclusive to ePen electronic cigarettes (available in monthly subscription). Sign up for additional privileges! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epen-3-cartridges/classic-peach-vpro-epen-3-cartridge/',
    title: 'Peach ePen Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'This peachy liquid has a slight floral note and is available in 0 and 12mg/ml nicotine (available in monthly subscription). Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epen-3-cartridges/classic-tobacco-vpro-epen-3-cartridge/',
    title: 'Classic Tobacco ePen, E-Liquid & E-Juice | By Vuse',
    description:
      'Classic Tobacco has a high intensity flavour with a darker smokier taste. Available in 0, 12 and 30mg/ml nicotine. Shop online for more favours!  Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epen-3-cartridges/dark-cherry-vpro-epen-3-cartridge/',
    title: 'Dark Cherry ePen Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our dark cherry has a subtle red fruit notes and is available in 0, 12 and 30mg/ml nicotine (available in monthly subscription). Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epen-3-cartridges/fresh-apple-vpro-epen-3-cartridge/',
    title: 'Green Apple & Mint ePen Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our apple pod has a cool mint aftertaste and is available in 0 and 12 mg/ml nicotine (available in monthly subscription). Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epen-3-cartridges/infused-vanilla-vpro-epen-3-cartridge/',
    title: 'Vanilla ePen Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our vanilla flavour has a smooth taste and a rich texture. Available in 0 and 12mg/ml nicotine (available in monthly subscription). Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epen-3-cartridges/original-strawberry-vpro-epen-3-cartridge/',
    title: 'Strawberry ePen Pods, E-Liquid & E-Juice| By Vuse',
    description:
      'Our strawberry flavour has a slight green fruit note and is available in 0, 12 and 30mg/ml nicotine. Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epen-3-cartridges/tropical-mango-vpro-epen-3-cartridge/',
    title: 'Mango ePen Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Discover our fruity mango liquid, available in 0 and 12mg/ml nicotine (available in monthly subscription). Shop our flavoured pods online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epen-3-cartridges/vape-pods-crushed-mint-epen-3-cartridge/',
    title: 'Crisp Mint ePen Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our spearmint & peppermint flavour is available in 0, 12 and 30mg/ml nicotine (available in monthly subscription). Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-charger/',
    title: 'ePod UBS Charger Cable ➡️ Order Online | By Vuse',
    description:
      'Recharge your device easily with the USB plug which allows you to connect it to your computer or to a wall plug.  Discover more accessories online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-skins/',
    title: 'ePod Skins - Vape Accessories | By Vuse',
    description:
      'Our vuse core skin collection fits the shape of the ePod perfectly and allows you to remove and replace it easily. Discover more accessories online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/',
    title: 'ePod Pods - Order E-Liquid & E-Juice Online | By Vuse',
    description:
      'Choose from a large variety of flavours, all exclusive to ePod electronic cigarettes (available in monthly subscription). Sign up for additional privileges! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/blood-orange-epod-cartridge/',
    title: 'Blood Orange ePod Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our blood orange flavour has a slight red pomgranate taste and is available in 1.6%, 3% and 5% nicotine by weight. Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/blueberry/',
    title: 'Blueberry ePod Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our blueberry flavour has a slight red fruit note and is available in 1.6%, 3% and 5% nicotine by weight. Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/epod-nicotine-salts-tobacco-marvel-vpro-cartridges/',
    title: 'Golden Tobacco ePod Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our golden tobacco flavour has well-balanced intensity, smooth taste and is available in 1.6%, 3% and 5% nicotine by weight. Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/epod-nicotine-salts-vanilla-medley/',
    title: 'Vanilla ePod Pods, E-Liquid & E-Juice| By Vuse',
    description:
      'Our vanilla flavour has a delicate taste and texture. It is available in 1.6%, 3% and 5% nicotine by weight. Find out more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/epod-vpro-cartridges-polar-mint/',
    title: 'Polar Mint ePod Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our polar mint e liquid is available in 0%, 1.6%, 3% and 5% nicotine by weight (available in monthly subscription). Find out more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/garden-strawberry/',
    title: 'Garden Strawberry ePod Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our strawberry liquid aroma has a slight green fruit hint and is available in 1.6%, 3% and 5% nicotine by weight. Find out more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/infused-cucumber-epod-cartridge/',
    title: 'Cucumber ePod Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our cucumber liquid aroma has a fresh taste and is available in 1.6%, 3% and 5% nicotine by weight. Find out more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/lychee-orchard/',
    title: 'Lychee ePod Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our lychee e liquid has a subtle mango hint and is available in 1.6%, 3% and 5% nicotine by weight. Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/passionfruit-fields/',
    title: 'Passion Fruit ePod Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our tropical passion fruit liquid has a slight almond taste and is available in 1.6%, 3% and 5% nicotine by weight. Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/buy-online/vype-epod-vpro-cartridges/watermelon/',
    title: 'Watermelon ePod Pods, E-Liquid & E-Juice | By Vuse',
    description:
      'Our watermelon liquid has a slight green note and is available in 1.6%, 3% and 5% nicotine by weight. Discover more flavours online! Previously govype.ca'
  },
  {
    url: '/faq/',
    title: 'E-Cigarette & Vape Frequently Asked Questions | By Vuse',
    description:
      'Find answers to the most frequently asked questions about E-Cigarette and Vuse Canada. We are here to help and guide you! Previously govype.ca'
  },
  {
    url: '/faq/what-is-vuse-epen3-how-to-use-it/',
    title: 'What is ePen Vape & How to use it⁉️ | By Vuse',
    description:
      'Find answers to the most frequently asked questions about ePen vapes with Vuse. We are here to help and guide you! Previously govype.ca'
  },
  {
    url: '/faq/what-is-vuse-epod-how-to-use-it/',
    title: 'What is ePod Vape & How to use it⁉️ | By Vuse',
    description:
      'Find answers to the most frequently asked questions about ePod vapes with Vuse. We are here to help and guide you! Previously govype.ca'
  },
  {
    url: '/pages/conditions-of-sale/',
    title: 'Conditions of Sale | By Vuse',
    description: 'Presentation of the conditions of Sale of Vuse Canada Previously govype.ca'
  },
  {
    url: '/pages/cookie-policy/',
    title: 'Cookie Policy | By Vuse',
    description:
      'To provide you with a smooth and personalized online experience, we collect and store navigational information.  Previously govype.ca'
  },
  {
    url: '/pages/privacy-policy/',
    title: 'Privacy poliy | By Vuse',
    description:
      'Confidentiality, security and respect regarding information exchanged between Vuse Canada and its clients.  Previously govype.ca'
  },
  {
    url: '/pages/subscription-terms-and-conditions/',
    title: 'How to Subscribe? Terms & conditions |By Vuse',
    description:
      'Presentation of the terms and conditions of use of Vuse subscription services. How to subscribe to our services directly online. Vuse e-pen and e-cigarette online. Previously govype.ca'
  },
  {
    url: '/pages/terms-conditions/',
    title: 'Terms & Conditions | Services |By Vuse',
    description:
      'Presentation of the terms and conditions of use of Vuse Canada services. Services, subscription and other terms for Vuse e-pen and e-cigarette online. Previously govype.ca'
  },
  {
    url: '/subscribe/',
    title: 'Subscribe easily: 💰 reduction and promotions | By Vuse',
    description:
      'Subscribe and Save! Get up to 30% on pods and get free shipping with our Vuse subscription plan.\nPreviously govype.ca'
  },
  {
    url: '/vape-stores/',
    title: 'Find a Vape Pen & E-Cigarette Retailor 📍 | By Vuse',
    description:
      'Find a Vuse e-cirgarette store near you across Canada 🍁. We sell on our online shop and also at retailers, use our map to find the closest for you 📍! Previously govype.ca'
  },
  {
    url: '/vuse-plus-vape-deals/',
    title: 'Vuse Plus Rewards Program ➡️ Subscribe Online | By Vuse',
    description:
      'Get the most out of your Vuse experience with exclusive offers, rewards 🎁, reductions and more! Subscribe and get up to 30% off pods and free shipping!  Previously govype.ca'
  },
  {
    url: '/vype-epod-starter-kit/',
    title: 'ePod Starter Kit ➡️ Shop our E-Cigarette Online | By Vuse',
    description:
      'Compact and stylish, discover ePod, a vape that offers a wide choice of flavours and is available in multiple color choices! Shop now! Previously govype.ca'
  },
  {
    url: '/vype-is-becoming-vuse/',
    title: 'Vype (Govype.ca) is becoming Vuse | Pen & E-Cigarette Shop',
    description:
      'Vype is transforming to Vuse, an internatinnal Brand new to Canada! Rest assured, Vuse pods are compatible with Vype devices & vice versa. Previously govype.ca'
  }
]
